import { SpaceState } from './-types'

export default (): SpaceState => ({
  space: '',
  gallery: [],
  photos: [],
  videos: []
})
